import { createSlice } from "@reduxjs/toolkit";
import {
  forgotPassword,
  getAdminUserDetails,
  login,
  resetNewPassword,
  resetPassword,
  validateUUID,
  verifyOtp,
} from "../actions/authSlice";

const initialState = {
  isLoggedIn: false,
  loading: false,
  isPermissionChecked: false,
  isLoading: false,
  authUser: {},
  accountType: null,
  adminPermissions: [],
  isGettingUserDetails: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsPermissionChecked: (state, action) => {
      state.isPermissionChecked = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.isLoggedIn = false;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data } = action.payload;

          const { role, accountType } = data || {};
          state.authUser = data;
          state.isLoggedIn = true;
          state.accountType = accountType;
          state.adminPermissions = role?.permissions;
          // SET DATA IN LOCAL DB
          localStorage.setItem("authUser", JSON.stringify(data));
          localStorage.setItem("isLoggedIn", true);
          localStorage.setItem("accountType", accountType);
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(forgotPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(verifyOtp.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(resetPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(validateUUID.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(validateUUID.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(validateUUID.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(resetNewPassword.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resetNewPassword.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(resetNewPassword.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getAdminUserDetails.pending, (state) => {
        state.isLoading = true;
        state.isGettingUserDetails = true;
      })
      .addCase(getAdminUserDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isGettingUserDetails = false;
        const { success } = action.payload || {};
        if (success) {
          const { data } = action.payload || {};
          const { role, accountType } = data || {};
          state.authUser = data;
          state.adminPermissions = role?.permissions;
          state.accountType = accountType;

          localStorage.setItem("authUser", JSON.stringify(data));
          localStorage.setItem("isLoggedIn", true);
          localStorage.setItem("accountType", accountType);
        }
      })
      .addCase(getAdminUserDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isGettingUserDetails = false;
      });
  },
});

export const { setIsPermissionChecked } = authSlice.actions;

export default authSlice.reducer;
